import { IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useAnalytics } from '@/hooks/useAnalytics';
import { GenericTrackTypes } from '@/types/genericTrackTypes';
import { useNavigationPreviousPage } from '@/hooks/useNavigationPreviousPage';
import styles from './BackButton.styles';

interface BackButtonProps {
  trackId: string;
  onClick?: () => void;
  size?: number;
}

export const BackButton: React.FC<BackButtonProps> = ({ trackId, onClick, size = 20 }) => {
  const navigatePreviousPage = useNavigationPreviousPage();
  const { track } = useAnalytics();

  const goBack = () => {
    track({
      action: GenericTrackTypes.BUTTON_PRESSED,
      category: `${trackId}:back_button`,
      label: 'Back Button',
    });
    if (onClick) {
      onClick();
    } else {
      navigatePreviousPage();
    }
  };

  return (
    <div className={styles.container}>
      <IconButton onClick={goBack} aria-label="Back to previous page" data-testid="backButton">
        <KeyboardArrowLeftIcon sx={{ fontSize: size }} />
      </IconButton>
    </div>
  );
};
